import Store from 'store/store';
import * as categories from 'utils/gdpr/categories';
import { dispatchEvent } from 'utils/gdpr/dispatchEvent';
import * as constants from 'utils/gdpr/constants';
import { oneTrust } from 'utils/gdpr';
// import { arrayContains } from 'utils/bolt';
import Cookies from 'js-cookie';

const POWSTER_COOKIE = 'pow-cookie-cats-';

Store.on('SET_COOKIE_BAR_HEIGHT', (val) => {
	Store.get().cookies.set({ height: val });
});

Store.on('COOKIE_BANNER_OPEN', () => {
	Store.get().cookies.set({ cookieBannerOpen: true });
});

Store.on('COOKIE_BANNER_CLOSE', () => {
	const store = Store.get();
	const cookiesStore = store.cookies;
	if (cookiesStore.cookieBannerOpen && cookiesStore.pushDown && cookiesStore.height && store.homeActivePercentage < .5) {
		let mainScroll = document.getElementById('mainScroll');
		if (mainScroll) {
			let destination = mainScroll.scrollTop + cookiesStore.height;
			// Some automatic scroll adjustment happening from some browser, so setTimeout to wait for a render
			setTimeout(() => {
				// Refetch in case the element has changed during the render
				let mainScroll = document.getElementById('mainScroll');
				if (mainScroll) {
					mainScroll.scrollTop = destination;
				}
			}, 0);
		}
	}
	cookiesStore.set({ cookieBannerOpen: false });
	Store.emit('SET_COOKIE_BAR_HEIGHT', 0);
});

Store.on('COOKIE_PREFERENCES_OPEN', () => {
	const { deviceSize } = Store.get().client;
	if (deviceSize !== 'mobile') {
		Store.emit('ENABLE_SCROLLING_LOCK');
	}
	Store.get().cookies.set({ cookiePreferencesOpen: true });
});

Store.on('COOKIE_PREFERENCES_CLOSE', () => {
	const { deviceSize } = Store.get().client;
	if (deviceSize !== 'mobile') {
		Store.emit('DISABLE_SCROLLING_LOCK');
	}
	Store.get().cookies.set({ cookiePreferencesOpen: false });
});

Store.on('ACCEPT_COOKIES', (cats = []) => {
	Store.emit('COOKIE_BANNER_CLOSE');
	categories.set(cats);
	Store.emit('SET_COOKIES', cats);
});

Store.on('ACCEPT_ALL_COOKIES', () => {
	const allCats = [...Object.keys(constants), 'UNCATEGORIZED'];
	Store.emit('ACCEPT_COOKIES', allCats);
});

Store.on('SET_COOKIES', (cats = []) => {
	Cookies.set(POWSTER_COOKIE + Store.get().appData?.meta?.id, cats, { expires: 30 });
});

Store.on('CHECK_COOKIES', () => {
	const allowedCategories = Cookies.getJSON(POWSTER_COOKIE + Store.get().appData?.meta?.id) || categories.get();
	const autoOptIn = Store.get().appData?.options?.cookiesModal?.autoOptIn || '';
	const autoOptInCategories = autoOptIn.split(',').filter(x => x);

	if (allowedCategories.length > 0) {
		Store.emit('ACCEPT_COOKIES', allowedCategories);
	} else if (autoOptInCategories.length > 0) {
		categories.set(autoOptInCategories);
	} else {
		categories.set([]);
	}
});

Store.on('ONETRUST_SHOW', () => oneTrust.displayModal());

Store.on('DELETE_ALL_COOKIES', ({ reload }) => {
	const cookies = Cookies.get();
	Object.keys(cookies).map(cookie => {
		if (!cookie.startsWith(POWSTER_COOKIE)) {
			Cookies.remove(cookie);
		}
	});

	if (reload) {
		window.location.reload();
	}
});

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
});
